import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=7e2c948e&scoped=true"
import script from "./FormSettings.vue?vue&type=script&lang=js"
export * from "./FormSettings.vue?vue&type=script&lang=js"
import style0 from "./FormSettings.vue?vue&type=style&index=0&id=7e2c948e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c948e",
  null
  
)

export default component.exports